module.exports = {"360724100":"东山镇","360724101":"陡水镇","360724102":"社溪镇","360724103":"营前镇","360724104":"黄埠镇","360724105":"寺下镇","360724200":"梅水乡","360724201":"油石乡","360724202":"安和乡","360724204":"双溪乡","360724205":"水岩乡","360724206":"平富乡","360724207":"五指峰乡","360724208":"紫阳乡","360724400":"上犹县黄埠工业区"}


//////////////////
// WEBPACK FOOTER
// ./src/town/360724.json
// module id = 1291
// module chunks = 0